import util from '../util.js'

//const pre_url = "http://192.168.2.4:5666";
//const pre_url = "http://127.0.0.1:5666";
const pre_url = "http://192.168.4.186:5666";

async function downloadFile(searchTable){
	let url = pre_url + "/file/download";
	let result = await util.request(url,{searchTable},'POST','blob');
	return result;
}

export default {
	pre_url,
	downloadFile
}


//////////////////
// WEBPACK FOOTER
// ./static/business/businessData.js
// module id = null
// module chunks = 